import { FC, ReactNode, useEffect } from 'react';

import { useAppDispatch, useTypedSelector } from '../../../store/store';
import { getVenue, getProperties } from '../../../store/slices/venue';
import { getUserIncentiveCampaigns } from '../../../store/slices/rewards';
import { getUserRequest } from '../../../store/slices/me';
import { httpClient } from '../../../services/httpClient/httpClient';
import { useRouter } from 'next/router';
import { AppContainer } from './InitialContainer.style';

interface InitialContainerProps {
  children: ReactNode;
}

export const InitialContainer: FC<InitialContainerProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { account } = useTypedSelector((state) => state.account);

  // Check if we're in slug-based routing mode
  const isSlugBasedRouting = router.pathname.startsWith('/[slug]');

  useEffect(() => {
    if (!isSlugBasedRouting) {
      dispatch(getVenue());
    }
  }, [isSlugBasedRouting, dispatch]);

  useEffect(() => {
    const userId = httpClient.getUserId();
    if (account.id) {
      dispatch(getProperties(account.id));
      if (userId) {
        dispatch(getUserRequest(userId));
        dispatch(getUserIncentiveCampaigns({ userId }));
      }
    }
  }, [dispatch, account.id]);

  // Theme is now managed at the app level in _app.tsx
  // This component handles data fetching and desktop layout constraint
  return <AppContainer>{children}</AppContainer>;
};
